import {
  MA_APP_IDS,
  withMembersArea,
  isMembersAreaInstalled,
  isMembersAreaAppInstalled,
  installMembersArea,
  registerMembersAreaApps,
  canInstallBlogWriterProfilesOnly,
} from '@wix/members-area-integration-kit';

export default {
  MA_APP_IDS,
  withMembersArea,
  isMembersAreaInstalled,
  isMembersAreaAppInstalled,
  installMembersArea,
  registerMembersAreaApps,
  canInstallBlogWriterProfilesOnly,
};
